import { Component, inject, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ButtonComponent } from "~app/common/components/button/button.component";
import { ListColumnDirective } from "~app/common/components/list/list-column.directive";
import { ListComponent } from "~app/common/components/list/list.component";
import { TextExpanderComponent } from "~app/common/components/text-expander/text-expander.component";
import { TextareaComponent } from "~app/common/components/textarea/textarea.component";
import { RaskCommonModule } from "~app/common/rask-common.module";
import { CommandService } from "~app/common/services/cqs/command.service";
import { CommandManager, ICommandManager } from "~app/common/services/cqs/commandManager";
import { DateUtils } from "~app/common/utils/date-utils";
import { UpdateArbetsorderRestriktionAnteckningCommand } from "../../commands/UpdateArbetsorderRestriktionAnteckningCommand";
import { IArbetsorderRestriktion, IAtgardRestriktion, IKartgeometriRestriktioner, IRestriktionKallaInfo } from "../../model/IArbetsorderRestriktion";
import { ArbetsorderService } from "../../services/arbetsorder.service";

@Component({
    selector: "rask-arbetsorder-restriktioner-anteckningar",
    imports: [
        FormsModule,
        ListComponent,
        ListColumnDirective,
        TextareaComponent,
        ButtonComponent,
        TextExpanderComponent,
        RaskCommonModule
    ],
    templateUrl: "./arbetsorder-restriktioner-anteckningar.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: "./arbetsorder-restriktioner-anteckningar.component.scss"
})
export class ArbetsorderRestriktionerAnteckningarComponent implements OnInit {
    readonly arbetsorderService = inject(ArbetsorderService);
    modal = inject(NgbActiveModal);
    data: any;
    restriktion: IArbetsorderRestriktion;
    restriktionKallor: IRestriktionKallaInfo[];
    private readonly commandManager: ICommandManager;
    private readonly commandService = inject(CommandService);
    constructor() {
        this.commandManager = new CommandManager();
    }

    ngOnInit(): void {
        this.arbetsorderService.getArbetsorderRestriktion(this.data.id).subscribe(x => {
            this.restriktion = x;
            this.restriktionKallor = x.atgardRestriktioner.map(y => this.mapAtgardRestriktionKalla(y));
            this.restriktionKallor = this.restriktionKallor.concat(x.kartgeometriRestriktioner.map(y => this.mapKartgeometriRestriktionKalla(y)));
        });
    }

    get senastAndradAnteckning(): string {
        return DateUtils.formatDateString(this.restriktion?.anteckningSenastAndrad, DateUtils.datetimeformatWithoutMillis);
    }

    protected UpdateRestriktionAnteckning(restriktion: IArbetsorderRestriktion, event: any) {
        this.commandManager.updateCommand(
            new UpdateArbetsorderRestriktionAnteckningCommand(command => {
                command.anteckning = event;
                command.arbetsorderId = this.data.arbetsorder.id;
                command.typ = restriktion.typ;
            }));
    }

    protected dismiss() {
        this.modal.close();
    }

    protected save() {
        this.commandService.pushCommands(this.commandManager);
        this.modal.close();
    }

    protected canSave(): boolean {
        return this.commandManager.isDirty();
    }

    private mapAtgardRestriktionKalla(item: IAtgardRestriktion): IRestriktionKallaInfo {
        return {
            anteckning: item.anteckning,
            kalla: item.kalla,
            beteckning: item.atgardBeteckning
        };
    }

    private mapKartgeometriRestriktionKalla(item: IKartgeometriRestriktioner): IRestriktionKallaInfo {
        return {
            anteckning: item.anteckning,
            kalla: item.kalla
        };
    }
}
